import React, { useState } from "react";
import { motion } from "framer-motion";
import { Play, X } from "lucide-react";

const updates = [
  { type: "image", url: "/images/b-21.jpeg" },
  { type: "image", url: "/images/b-11.jpeg" },
  { type: "video", url: "/images/v6.mp4", thumbnail: "/images/b-1.jpeg" },
  { type: "image", url: "/images/11.jpeg" },
  { type: "video", url: "/images/v1.mp4", thumbnail: "/images/b-2.jpeg" },
  { type: "image", url: "/images/17.jpeg" },
  { type: "image", url: "/images/12.jpeg" },
  { type: "video", url: "/images/v7.mp4", thumbnail: "/images/b-3.jpeg" },
  { type: "image", url: "/images/b-20.jpeg" },
];

const RecentUpdates = () => {
  const [popup, setPopup] = useState<null | { type: string; url: string }>(
    null
  );

  return (
    <section className="relative py-16 bg-gray-50 dark:bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Heading */}
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-gray-900 dark:text-white">
            Our <span className="text-yellow-500">Recent Updates</span>
          </h2>
          <p className="mt-3 text-base sm:text-lg text-gray-600 dark:text-gray-400">
            Explore our latest architectural and interior projects. Click on images or videos to view them in detail.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6">
          {updates.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="relative group overflow-hidden rounded-xl shadow-lg hover:shadow-2xl cursor-pointer"
              onClick={() => setPopup({ type: item.type, url: item.url })}
            >
              <div className="w-full aspect-[4/3] sm:aspect-[16/9] md:aspect-[4/3]">
                <img
                  src={item.type === "video" ? item.thumbnail! : item.url}
                  alt={`update-${index}`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110 rounded-xl"
                />
                {item.type === "video" && (
                  <div className="absolute inset-0 flex items-center justify-center bg-black/40 group-hover:bg-black/60 transition rounded-xl">
                    <Play className="w-12 h-12 text-white" />
                  </div>
                )}
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Popup Modal */}
      {popup && (
        <div
          className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4 sm:p-6"
          onClick={() => setPopup(null)}
        >
          <div
            className="relative w-full max-w-3xl sm:max-w-5xl mx-auto"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              aria-label="Close popup"
              className="absolute top-2 right-2 text-white bg-black/50 rounded-full p-1 hover:bg-black/70 z-50"
              onClick={() => setPopup(null)}
            >
              <X className="w-6 h-6" />
            </button>

            {popup.type === "image" ? (
              <img
                src={popup.url}
                alt="popup"
                className="w-full h-auto rounded-lg shadow-lg object-contain"
              />
            ) : (
              <video
                src={popup.url}
                controls
                autoPlay
                className="w-full h-auto rounded-lg shadow-lg object-contain"
              />
            )}
          </div>
        </div>
      )}
    </section>
  );
};

export default RecentUpdates;
